import React from "react";

export default function NewsBanner() {
  const fontStyle = { fontFamily: "'Inter', sans-serif" };

  return (
    <div
      className="!font-inter !relative !overflow-hidden !rounded-2xl !bg-gradient-to-r !from-[#053c7f] !via-[#0a4d9c] !to-[#0284c7] !p-5 sm:!p-6 md:!p-7 !text-white !shadow-md !border !border-blue-900/20"
      style={fontStyle}
    >
      {/* Decorative background effects */}
      <div className="!absolute !-right-16 !-bottom-16 !w-80 !h-80 !rounded-full !bg-white/10 !blur-3xl !pointer-events-none" />
      <div className="!absolute !left-1/3 !-top-12 !w-64 !h-64 !rounded-full !bg-cyan-300/10 !blur-2xl !pointer-events-none" />
      <div className="!absolute !inset-0 !bg-[radial-gradient(#ffffff0f_1px,transparent_1px)] ![background-size:16px_16px] !pointer-events-none !opacity-40" />

      <div className="!relative !z-10 !flex !flex-col lg:!flex-row lg:!items-center !justify-between !gap-5" style={fontStyle}>
        {/* Brand, Title & Subtitle */}
        <div className="!max-w-3xl !space-y-2.5" style={fontStyle}>
          <div className="!flex !flex-wrap !items-center !gap-2.5">
            <span
              className="!inline-flex !items-center !gap-1.5 !px-3 !py-1 !rounded-full !text-sm !font-bold !tracking-wide !uppercase !bg-white/15 !text-cyan-100 !border !border-white/20 !backdrop-blur-md"
              style={fontStyle}
            >
              <span className="!w-2 !h-2 !rounded-full !bg-emerald-400 !animate-pulse" />
              Hệ thống Kho & Vật Tư ICOOL
            </span>
            <span className="!text-sm !text-blue-100/90 !font-medium !hidden sm:!inline-block" style={fontStyle}>
              Kho Trung Tâm &bull; Bếp Trung Tâm &bull; Chi Nhánh
            </span>
          </div>

          <div>
            <h1 className="!text-2xl sm:!text-3xl !font-black !text-white !drop-shadow-xs !flex !items-center !gap-3" style={fontStyle}>
              <span>BẢNG TIN KHO</span>
            </h1>
            <p className="!text-blue-50 !text-sm sm:!text-base !font-normal !mt-1 !max-w-2xl !leading-relaxed" style={fontStyle}>
              Theo dõi tổng hợp các phiếu nghiệp vụ chờ duyệt và bảng tin thông báo điều hành.
            </p>
          </div>
        </div>

        {/* Right Column: Warehouse Badge */}
        <div className="!flex !items-center !gap-3 !shrink-0 !pt-2 lg:!pt-0 !border-t lg:!border-t-0 !border-white/15" style={fontStyle}>
          <div className="!flex !items-center !gap-3 !bg-white/15 !backdrop-blur-md !px-4 !py-3 !rounded-xl !border !border-white/20 !text-sm !shadow-xs" style={fontStyle}>
            <div className="!w-10 !h-10 !rounded-lg !bg-white/20 !border !border-white/30 !flex !items-center !justify-center !text-cyan-100">
              <svg
                className="!w-5 !h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
                />
              </svg>
            </div>
            <div style={fontStyle}>
              <div className="!text-sm !text-blue-100 !font-medium" style={fontStyle}>
                Kho ICOOL
              </div>
              <div className="!text-sm !font-bold !text-white !tracking-wide" style={fontStyle}>
                BẢNG TIN NỘI BỘ
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
